// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3YCa1","topBottomGutter":"Layout_topBottomGutter__31ji1"};